import { useFieldArray, useFormContext } from "react-hook-form";

import { Delete as DeleteIcon } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { OutletAutocomplete } from "../../../outlets/outlet-autocomplete";

export const OutletAvailabilitySection = () => {
  const { control } = useFormContext();

  const {
    fields: warehouseOutlets,
    append,
    update,
    remove,
  } = useFieldArray({
    control,
    name: "warehouseOutlets",
  });

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 6 }}>
          <Typography variant="h6">Outlet</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 8, lg: 6 }}>
          <OutletAutocomplete
            excludeIds={warehouseOutlets.map(
              (warehouseOutlet) => warehouseOutlet.outletId
            )}
            onChange={(outlet) => {
              append({
                outletId: outlet.id,
                outletName: outlet.name,
                type: "GENERAL",
              });
            }}
          />
        </Grid>
      </Grid>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Outlet</TableCell>
              <TableCell>Gudang Default</TableCell>
              <TableCell>Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {warehouseOutlets.map((warehouseOutlet, index) => (
              <TableRow key={warehouseOutlet.id}>
                <TableCell>{warehouseOutlet.outletName}</TableCell>
                <TableCell>
                  <Switch
                    checked={warehouseOutlet.type === "DEFAULT"}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      if (isChecked) {
                        // Set this outlet as "DEFAULT" and reset others to "GENERAL"
                        warehouseOutlets.forEach((item, i) => {
                          update(i, {
                            ...item,
                            type: i === index ? "DEFAULT" : "GENERAL",
                          });
                        });
                      } else {
                        // Only update this specific item when toggling off
                        update(index, {
                          ...warehouseOutlet,
                          type: "GENERAL",
                        });
                      }
                    }}
                  />
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => remove(index)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
